import type { HTMLAttributes, ReactNode } from 'react'
import styles from './Section.module.css'

export type SectionSpacing = 'sm' | 'md' | 'lg' | 'xl'

export interface SectionProps extends HTMLAttributes<HTMLElement> {
  spacing?: SectionSpacing
  border?: boolean
  children: ReactNode
}

export function Section({
  spacing = 'lg',
  border,
  children,
  className,
  ...props
}: SectionProps) {
  const classes = [
    styles.section,
    styles[`spacing-${spacing}`],
    border && styles.border,
    className,
  ].filter(Boolean).join(' ')

  return (
    <section className={classes} {...props}>
      {children}
    </section>
  )
}
